import { render, staticRenderFns } from "./content-history.vue?vue&type=template&id=95f11c50&"
import script from "./content-history.vue?vue&type=script&lang=js&"
export * from "./content-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports